<template>
  <div>
    <v-row class="px-2">
      <v-col
        cols="12"
        md="10"
      >
        <area-chart
          :colors="['#337ab7', '#c9302c']"
          :download="true"
          :round="2"
          :zeros="true"
          :legend="true"
          :data="chart"
        />
      </v-col>
      <v-col
        cols="12"
        md="2"
      >
        <v-list
          rounded
          dense
        >
          <v-list-item-group>
            <v-list-item>
              <v-list-item-content class="text-left">
                <v-list-item-title>Sales</v-list-item-title>
                <v-list-item-subtitle>
                  {{ dashborad.sales | currency }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="text-left">
                <v-list-item-title>Sold</v-list-item-title>
                <v-list-item-subtitle>
                  {{ dashborad.sold }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="text-left">
                <v-list-item-title>Cost</v-list-item-title>
                <v-list-item-subtitle>
                  {{ dashborad.cost | currency }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="text-left">
                <v-list-item-title>Profit</v-list-item-title>
                <v-list-item-subtitle>
                  {{ dashborad.profit | currency }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="text-left">
                <v-list-item-title>Tax</v-list-item-title>
                <v-list-item-subtitle>
                  {{ dashborad.tax | currency }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="5"
      >
        <pie-chart
          :download="true"
          :data="pieChart"
        />
      </v-col>
      <v-col
        cols="12"
        md="7"
      >
        <send-mail />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Mail from "./common/MailComponent.vue";
export default {
  components: {
    "send-mail": Mail,
  },
  data() {
    return {
      priceChart: {},
      costChart: {},
      dashborad: {},
      today: {
        sales: 78,
        sold: 4,
        transactions: 4,
        cost: 50,
        tax: 55,
      },
    };
  },

  computed: {
    pieChart() {
      return [
        ["Sales", this.$data.dashborad.sales],
        ["Sold", this.$data.dashborad.sold],
        ["Profit", this.$data.dashborad.profit],
        ["Cost", this.$data.dashborad.cost],
        ["Tax", this.$data.dashborad.tax],
      ];
    },
    chart() {
      return [
        {
          name: "Sale",
          data: this.$data.dashborad.areaChartPrice,
        },
        {
          name: "Cost",
          data: this.$data.dashborad.areaChartCost,
        },
      ];
    },
  },
  mounted() {
    this.getFromApi();
  },
  methods: {
    getFromApi() {
      window.axios.get("/dashboard-chart").then((response) => {
        this.$data.dashborad = response.data;
      });
    },
  },
};
</script>
